import { ProductCenterRouteMap } from '@/new-router/product-center'

const productRunning = () => import('@/views/DayanTask/productRunning')
const productEnd = () => import('@/views/DayanTask/productEnd')
const rebuildEnd = () => import('@/views/DayanTask/rebuildEnd')
const dytask = () => import('@/views/DayanTask/dytask')
const emptyThreeRunning = () => import('@/views/DayanTask/emptyThreeRunning')
const rebuildRunning = () => import('@/views/DayanTask/rebuildRunning')
const Home = () => import('@/views/Home/home')
const sky3End = () => import('@/views/DayanTask/sky3End')
const publish = () => import('@/views/DayanTask/publish')
const LogDetails = () => import('@/views/DayanTask/LogDetails')
const taskDetail = () => import('@/views/DayanTask/taskDetail')
const configDetails = () => import('@/views/DayanTask/configDetails')

/**
* hidden: true                   是否显示在侧栏上
  name: 'XXXX'                   翻译字段的标识
* meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
    nocache: true                组件将不keep-alive
    permission: 'XXXX'           v-permission对应的字段名
  }
**/

export default [
  {
    path: '/dayanTask',
    name: 'dayanTask',
    component: Home,
    meta: {
      title: '大雁云作业管理',
      icon: 'icon-task',
      showSubiems: false,
      sort: 3,
      permission: 'dyy:task:root',
      modules: 'dayanTask',
    },
    children: [
      {
        path: 'dyOverview',
        name: 'dytaskOverview',
        component: dytask,
        meta: {
          title: '节点机分布概览',
          active: ['dytaskOverview'],
          permission: 'dyy:node:distribute',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.DaYan, ProductCenterRouteMap.TaskManagement],
        },
      }, {
        path: 'emptyThreeRunning',
        name: 'emptyThreeRunning',
        component: emptyThreeRunning,
        meta: {
          title: '运行的空三作业',
          active: ['emptyThreeRunning', 'sky3RunningLogDetails', 'sky3RunningDetail', 'sky3RunningConfigDetails'],
          permission: 'dyy:running:kongsan:task',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.DaYan, ProductCenterRouteMap.TaskManagement],
        },
      }, {
        path: 'sky3/end',
        name: 'sky3End',
        component: sky3End,
        meta: {
          title: '完成的空三作业',
          active: ['sky3End', 'sky3EndLogDetails', 'sky3EndDetail', 'sky3EndConfigDetails'],
          permission: 'dyy:complete:kongsan:task',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.DaYan, ProductCenterRouteMap.TaskManagement],
        },
      }, {
        path: 'rebuild/running',
        name: 'rebuildRunning',
        component: rebuildRunning,
        meta: {
          title: '运行的重建作业',
          active: ['rebuildRunning', 'rebuildRunningLogDetails', 'rebuildRunningDetail', 'rebuildRunningConfigDetails'],
          permission: 'dyy:running:rebuild:task',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.DaYan, ProductCenterRouteMap.TaskManagement],
        },
      }, {
        path: 'rebuild/end',
        name: 'rebuildEnd',
        component: rebuildEnd,
        meta: {
          title: '完成的重建作业',
          active: ['rebuildEnd', 'rebuildEndLogDetails', 'rebuildEndDetail', 'rebuildEndConfigDetails'],
          permission: 'dyy:complete:rebuild:task',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.DaYan, ProductCenterRouteMap.TaskManagement],
        },
      }, {
        path: 'product/running',
        name: 'productRunning',
        component: productRunning,
        meta: {
          title: '运行的生产作业',
          active: ['productRunning', 'productRunningDetail', 'productRunningConfigDetails', 'productRunningLogDetails'],
          permission: 'dyy:running:product:task',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.DaYan, ProductCenterRouteMap.TaskManagement],
        },
      }, {
        path: 'product/end',
        name: 'productEnd',
        component: productEnd,
        meta: {
          title: '完成的生产作业',
          active: ['productEnd', 'productEndDetail', 'productEndConfigDetails', 'productEndLogDetails'],
          permission: 'dyy:complete:product:task',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.DaYan, ProductCenterRouteMap.TaskManagement],
        },
      }, {
        path: 'publish',
        name: 'publish',
        component: publish,
        meta: {
          title: '发布作业',
          active: ['publish'],
          permission: 'dyy:query:publish:task',
        },
      }, {
        path: 'sky3EndLogDetails/:taskId',
        name: 'sky3EndLogDetails',
        component: LogDetails,
        hidden: true,
        meta: {
          title: '完成的空三作业日志详情',
          nocache: true,
        },
      }, {
        path: 'sky3RunningLogDetails/:taskId',
        name: 'sky3RunningLogDetails',
        component: LogDetails,
        hidden: true,
        meta: {
          title: '运行的空三作业日志详情',
          nocache: true,
        },
      }, {
        path: 'rebuildRunningLogDetails/:taskId',
        name: 'rebuildRunningLogDetails',
        component: LogDetails,
        hidden: true,
        meta: {
          title: '运行的重建作业日志详情',
          nocache: true,
        },
      }, {
        path: 'rebuildEndLogDetails/:taskId',
        name: 'rebuildEndLogDetails',
        component: LogDetails,
        hidden: true,
        meta: {
          title: '完成的重建作业日志详情',
          nocache: true,
        },
      }, {
        path: 'productRunningLogDetails/:id/:taskId',
        name: 'productRunningLogDetails',
        component: LogDetails,
        hidden: true,
        meta: {
          title: '运行的生产作业日志详情',
          nocache: true,
        },
      }, {
        path: 'productEndLogDetails/:id/:taskId',
        name: 'productEndLogDetails',
        component: LogDetails,
        hidden: true,
        meta: {
          title: '完成的生产作业日志详情',
          nocache: true,
        },
      }, {
        path: 'productRunningDetail/:taskId/:userId',
        name: 'productRunningDetail',
        component: taskDetail,
        hidden: true,
        meta: {
          title: '运行生产瓦片任务详情',
          nocache: true,
        },
      }, {
        path: 'productEndDetail/:taskId/:userId',
        name: 'productEndDetail',
        component: taskDetail,
        hidden: true,
        meta: {
          title: '完成生产瓦片任务详情',
          nocache: true,
        },
      }, {
        path: 'sky3RunningDetail/:taskId/:userId',
        name: 'sky3RunningDetail',
        component: taskDetail,
        hidden: true,
        meta: {
          title: '运行的空三瓦片任务详情',
          nocache: true,
        },
      }, {
        path: 'sky3EndDetail/:taskId/:userId',
        name: 'sky3EndDetail',
        component: taskDetail,
        hidden: true,
        meta: {
          title: '完成的空三瓦片任务详情',
          nocache: true,
        },
      }, {
        path: 'rebuildRunningDetail/:taskId/:userId',
        name: 'rebuildRunningDetail',
        component: taskDetail,
        hidden: true,
        meta: {
          title: '运行的重建瓦片任务详情',
          nocache: true,
        },
      }, {
        path: 'rebuildEndDetail/:taskId/:userId',
        name: 'rebuildEndDetail',
        component: taskDetail,
        hidden: true,
        meta: {
          title: '完成的重建瓦片任务详情',
          nocache: true,
        },
      }, {
        path: 'sky3EndConfigDetails/:taskId/:userId/:taskFlag',
        name: 'sky3EndConfigDetails',
        component: configDetails,
        hidden: true,
        meta: {
          title: '完成的空三配置文档详情',
          nocache: true,
        },
      }, {
        path: 'productRunningConfigDetails/:taskId/:userId/:taskFlag',
        name: 'productRunningConfigDetails',
        component: configDetails,
        hidden: true,
        meta: {
          title: '运行的生产配置文档详情',
          nocache: true,
        },
      }, {
        path: 'productEndConfigDetails/:taskId/:userId/:taskFlag',
        name: 'productEndConfigDetails',
        component: configDetails,
        hidden: true,
        meta: {
          title: '完成的生产配置文档详情',
          nocache: true,
        },
      }, {
        path: 'sky3RunningConfigDetails/:taskId/:userId/:taskFlag',
        name: 'sky3RunningConfigDetails',
        component: configDetails,
        hidden: true,
        meta: {
          title: '运行的空三配置文档详情',
          nocache: true,
        },
      }, {
        path: 'rebuildEndConfigDetails/:taskId/:userId/:taskFlag',
        name: 'rebuildEndConfigDetails',
        component: configDetails,
        hidden: true,
        meta: {
          title: '完成的重建配置文档详情',
          nocache: true,
        },
      }, {
        path: 'rebuildRunningConfigDetails/:taskId/:userId/:taskFlag',
        name: 'rebuildRunningConfigDetails',
        component: configDetails,
        hidden: true,
        meta: {
          title: '运行的重建配置文档详情',
          nocache: true,
        },
      },
    ],
  },
]
